import AppConfig from "../AppConfig.js";

class URLUtil {
  static getRootURL = () => {
    let sRootURL = window.location.host;

    if ( sRootURL === 'localhost' || sRootURL === 'localhost:5173' )
    {
      // sRootURL = 'https://localhost:5173/lifestyleresorts.nl';
      sRootURL = 'https://localhost/lifestyleresorts.nl';
    }

    return "https://" + sRootURL;
  }


  // static getServerRootUrl = () => {
  //   let sUrl = '';
  //   if ( window.location.host !== undefined && window.location.host !== null )
  //   {
  //     if ( window.location.host === 'localhost' )
  //     {
  //       sUrl = 'http://localhost/lifestyleresorts.nl';
  //     }
  //     else
  //     {
  //       sUrl = '';
  //     }
  //   }
  //
  //   return sUrl;
  // };

  /**
   * Functie die ervoor moet zorgen dat meertalige urls blijven werken zonder per taal een url endpoint te hoeven configureren voor Ajax calls
   * @param sSegment
   * @returns {string}
   */
  static getCurrentPageRelativeLink = (sSegment) => {
    let sCurrentUrl = window.location.href;
    let aUrlParts = sCurrentUrl.split('/');
    let aResponse = [];

    let bIsPastDomain = false;
    for ( let i = 0; i < aUrlParts.length; ++i )
    {
      // voeg toe
      if ( bIsPastDomain === true && aUrlParts[i].trim() !== '' ) aResponse.push(aUrlParts[i]);

      // zijn we hierna voor het eerst na de domeinnaam
      if ( aUrlParts[i].indexOf('.nl') > -1 )
      {	// dit onderdeel van de url bevat thermensoesterberg.nl -> dit werkt lokaal, live en afhankelijk van de url mogelijk ook test
        bIsPastDomain = true;
      }
    }

    aResponse.push(sSegment);

    return aResponse.join('/');
  };

  static getCurrentPageAbsoluteLink = (sSegment) => {
    let sCurrentUrl = window.location.href;
    let aUrlParts = sCurrentUrl.split('/');
    let aResponse = [];

    for ( let i = 0; i < aUrlParts.length; ++i )
    {
      // voeg toe
      if ( aUrlParts[i].trim() !== '' ) aResponse.push(aUrlParts[i]);

      // als dit 'stap' is dan stoppen we hierna omdat de rest dynamisch is
      if ( aUrlParts[i] === 'reserveren' ) break;
    }

    if ( aResponse[aResponse.length - 1] !== 'reserveren' ) aResponse.push('reserveren');

    aResponse.push(sSegment);

    return aResponse.join('/');
  };

  static getCurrentPageRelativeLinkWithoutAction = () => {
    if ( AppConfig.bDebugUseLocalRootURL )
    {
      return '';
    }

    return 'reserveren';
  };

  static getUrlVars = () => {
    let vars = {};
    let parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
      vars[key] = value;
    });

    return vars;
  };
}

export default URLUtil;